var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landStatistical"},[_vm._v(" landStatistical ")])
}
var staticRenderFns = []

export { render, staticRenderFns }